import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout';
import { HomePage } from '@/routes/HomePage';
import { PlacesPage } from '@/routes/PlacesPage';
import { PlaceDetailPage } from '@/routes/PlaceDetailPage';
import { FavoritesPage } from '@/routes/FavoritesPage';
import { ResortPage } from '@/routes/ResortPage';
import { MapPage } from '@/routes/MapPage';
import { FlightsPage } from '@/routes/FlightsPage';
import { MorePage } from '@/routes/MorePage';
import { EventsPage } from '@/routes/EventsPage';
import { SafetyPage } from '@/routes/SafetyPage';
import { EmergencyPage } from '@/routes/EmergencyPage';
import { MedicalPage } from '@/routes/MedicalPage';
import { ExplorePage } from '@/routes/ExplorePage';
import { SettingsPage } from '@/routes/SettingsPage';
import { PronunciationPage } from '@/routes/PronunciationPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/places" element={<PlacesPage />} />
        <Route path="/places/:slug" element={<PlaceDetailPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/resort" element={<ResortPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/flights" element={<FlightsPage />} />
        <Route path="/more" element={<MorePage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/emergency" element={<EmergencyPage />} />
        <Route path="/medical" element={<MedicalPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/pronunciation" element={<PronunciationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
